import { ReactComponent as ChevronIcon } from '@vkontakte/icons/src/svg/16/chevron_outline_16.svg';
import classNames from 'clsx';
import React, { useState } from 'react';
import { getDomainRestrictionsForItems } from 'reactApp/appHelpers/appHelpers';
import { isPublicPasswordEnabled } from 'reactApp/appHelpers/featuresHelpers/features/publicPassword';
import type { XrayItemType } from 'reactApp/modules/home/home.types';
import type { PublishItem } from 'reactApp/modules/modifying/modifying.types';

import { DownloadsCountDropdown } from '../../SharingWindow/blocks/SharingOptions/DownloadsCountDropdown/DownloadsCountDropdown';
import { ExpiriesDwopdown } from '../ExpiriesDwopdown/ExpiriesDwopdown';
import styles from './AdditionalSettings.css';

interface Props {
    item?: PublishItem;
    isWeblinkOpened: boolean;
    showExpires: boolean;
    isDownloadable?: boolean;
    isPhone?: boolean;
    xrayItemType: XrayItemType;
}

const AdditionalSettings: React.FC<Props> = ({ item, isWeblinkOpened, showExpires, isDownloadable, isPhone, xrayItemType }) => {
    const [isOpened, setIsOpened] = useState(false);
    const { isDomainAndDownloadRestricted } = getDomainRestrictionsForItems(item);
    const showDownloads = !isDomainAndDownloadRestricted;

    return (
        <>
            {isWeblinkOpened && (
                <>
                    <div
                        className={classNames(styles.toggler, {
                            [styles.toggler_opened]: isOpened,
                            [styles.toggler_pub_pasw]: isPublicPasswordEnabled,
                            [styles.toggler_phone]: isPhone,
                        })}
                        onClick={() => setIsOpened(!isOpened)}
                    >
                        Дополнительные настройки
                        <ChevronIcon />
                    </div>
                    <div className={classNames(styles.content, { [styles.content_opened]: isOpened })}>
                        {showExpires && <ExpiriesDwopdown item={item} xrayItemType={xrayItemType} />}
                        {showDownloads && (
                            <DownloadsCountDropdown item={item} isDownloadable={isDownloadable} xrayItemType={xrayItemType} />
                        )}
                    </div>
                </>
            )}
        </>
    );
};

export default AdditionalSettings;
